/**
   * Function: getResponse
   * @description Simply retrieves the response from
   * the API.
   *
   * @param {object} response
*/
export const getResponse = response => {
   if(response?.data?.data)
      return response.data.data
}

/**
   * Function: getMeta
   * @description Simply retrieves the meta response from
   * the API.
   *
   * @param {object} response
*/
export const getMeta = response => {
   if(response?.data?.meta)
      return response.data.meta
}

/**
   * Function: getError
   * @description Simply retrieves the error from
   * the API response.
   *
   * @param {object} response
*/
export const getError = response => response?.response?.data?.message